export const THEME_COLOR_1 = 'color_36';
export const THEME_COLOR_2 = 'color_37';
export const LUMINOSITY_THRESHOLD = 145;
export const MAX_SUBSAMPLE_WIDTH = 300;
export const MAX_SUBSAMPLE_HEIGHT = 300;
